import React, { Component } from 'react';
import PropTypes from 'prop-types';

import InvitationModal from './InvitationModal';
import { Loader } from '../Loading';
import DashboardLayout from '../DashboardLayout';
import GenericNotFound from '../GenericNotFound';
import { intlShape, injectIntl } from 'react-intl';

/**
 * View component for the invitation page, 
 * where users arrive when they click on an invitation link
 */
class InvitationPage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentWillMount() {
    const { loadData } = this.props;
    loadData()
      .then(action => {
        if (action.error) {
          // FIXME
          this.setState({ notFound: true });
        }
      })
  }
  render() {
    const {
      intl,
      user,
      invitation,
      handleDeny,
      handleAccept
    } = this.props;

    const {
      notFound
    } = this.state;

    if (notFound) {
      return (
        <DashboardLayout>
          <GenericNotFound
            message={
              intl.messages['invitation.notFound']
            } />
        </DashboardLayout>
      );
    }

    return (
      <DashboardLayout>
        {invitation && invitation.licence
          ? <InvitationModal
              invitation={invitation}
              handleAccept={_ => handleAccept({ user })}
              handleDeny={_ => handleDeny({ user })} />
          : <Loader />
        }
      </DashboardLayout>
    );
  }
}

InvitationPage.propTypes = {
  intl: intlShape.isRequired,
  loadData: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  handleAccept: PropTypes.func.isRequired,
  handleDeny: PropTypes.func.isRequired
}

export default injectIntl(InvitationPage);


// WEBPACK FOOTER //
// ./src/components/invitations/InvitationPage.js